import _export from '../internals/export.js';
import descriptors from '../internals/descriptors.js';
import anObject$1 from '../internals/an-object.js';
import '../internals/object-get-own-property-descriptor.js';
import { __exports as objectGetOwnPropertyDescriptor } from '../../../../../../_virtual/object-get-own-property-descriptor.js';

var $ = _export;
var DESCRIPTORS = descriptors;
var anObject = anObject$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor; // `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor

$({
  target: 'Reflect',
  stat: true,
  sham: !DESCRIPTORS
}, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
  }
});
